import {
  useCreateProjectApi,
  useDeleteProjectApi,
  useGetProjectApi,
  useListProjectsApi,
  useUpdateProjectApi,
} from '@/api/projects';
import { useMemo } from 'react';

export const useProjectsService = () => {
  const { data, ...rest } = useListProjectsApi();

  const projects = useMemo(() => {
    return data ?? [];
  }, [data]);

  return { projects, ...rest };
};

export const useProjectService = (id: string) => {
  const { data, ...rest } = useGetProjectApi(id);

  return { project: data, ...rest };
};

export const useCreateProjectService = () => {
  const { mutate: createProject, isPending: isCreating } =
    useCreateProjectApi();

  return { createProject, isCreating };
};

export const useUpdateProjectService = () => {
  const { mutate: updateProject, isPending: isUpdating } =
    useUpdateProjectApi();

  return { updateProject, isUpdating };
};

export const useDeleteProjectService = () => {
  const { mutate: deleteProject, isPending: isDeleting } =
    useDeleteProjectApi();

  return { deleteProject, isDeleting };
};
